import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  currentPage: 1,
  scrollPage:1,
  currentFilter: null,
  currentPageSize: 10,
  startDate: null,
  endDate: null,
  clearSelection: false,
  queryData: {},
  queryStatus: "idle",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  showEditModal: false,
  selectedId: "",
  selectedItemsDetails: "",
  is_edit: false,
};


export const createNewEntry = createAsyncThunk(
  "/v1/admin/policy/update-or-create",
  async (data, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post("/v1/admin/policy/update-or-create", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const termsAndConditionSlice = createSlice({
  name: "termsAndCondition",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  
});

export const { updateConfig } = termsAndConditionSlice.actions;

export default termsAndConditionSlice.reducer;
